import NumberListFormItem from 'components/Application/InitialApplication/NumberListFormItem';
import TextHeader from 'components/CustomText/TextHeader';
import TextSubHeader from 'components/CustomText/TextSubHeader';
import React, { useEffect, useState } from 'react';
import styled from 'styled-components/macro';
import useCTAAmendmentData from 'hooks/tableData/useCTAAmendmentData';
import CustomTable from 'components/CustomTable';
import useProgressReportSubmissionData from 'hooks/tableData/useProgressReportSubmissionData';
import useStatusHistoryData from 'hooks/tableData/useStatusHistoryData';
import useApprovalHistoryData from 'hooks/tableData/useApprovalHistoryData';
import useDocumentLogData from 'hooks/tableData/useDocumentLogData';
import useQuery from 'hooks/useQuery';
import CustomButton from 'components/CustomInput/Button';
import { ACKNOWLEDGED, APPROVED, CCO, DISAPPROVED, IRB, SECRETARY, KEY_PATHNAME } from 'utility/lookup';
import { useHistory } from 'react-router';
import useCTCExpiryDateData from 'hooks/tableData/useCTCExpiryDateData';
import useCTIExpiryDateData from 'hooks/tableData/useCTIExpiryDateData';
import { getTimeWithTimeZone } from 'utility/general';

import api from 'api/call';
import { checkNull } from 'utility/formValidate';
import { useSelector, useDispatch } from 'react-redux';
import { getItem } from 'storage';
import { setGlobal } from 'store/global/reducer';
const SLayout = styled.div`
    padding: 15px;
`;

const SButtonLayout = styled.div`
    display: flex;
`;

const SLoadingLayout = styled.div`
    display: flex;
    height: 100%;
    justify-content: center;
    align-items: center;
`;

const ApplicationHistory = ({ props }) => {
    const [data, setData] = useState({});
    const [isLoading, setLoading] = useState(false);
    const [isError, setError] = useState(false);
    const user = useSelector((state) => state.user);
    const application = useSelector((state) => state.application);
    const dispatch = useDispatch();

    const { rows: ctcRow, columns: ctcColumns } = useCTCExpiryDateData(data);
    const { rows: ctiRow, columns: ctiColumns } = useCTIExpiryDateData(data);
    const { rows: ctaRows, columns: ctaColumns } = useCTAAmendmentData(data);
    const { rows: progressRows, columns: progressColumns } = useProgressReportSubmissionData(data);
    const { rows: statusRows, columns: statusColumns } = useStatusHistoryData(data);
    const { rows: approvalRows, columns: approvalColumns } = useApprovalHistoryData(data);
    const { rows: documentRows, columns: documentColumns } = useDocumentLogData(data);
    const history = useHistory();
    const formId = useQuery('id');

    useEffect(() => {
        setLoading(true);

        api.application
            .getApplicationHistory(formId)
            .then((res) => {
                setData(res.data.result);
            })
            .catch((err) => {
                setError(true);
            })
            .finally(() => {
                setLoading(false);
            });

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    // if (!currentApplication) {
    //     return 'no application is found';
    // }
    if (isLoading) {
        return <SLoadingLayout>Loading application history...</SLoadingLayout>;
    }

    if (isError) {
        return <SLoadingLayout>Fetch application history with error!</SLoadingLayout>;
    }

    const {
        subNo,
        refNo,
        submissionDate,
        confirmDate,
        reviewBoard,
        reviewDecision,
        p4SponsorType,
        typeOfReview,
        decisionDate,
        ctaRequired,
        ctcRequired,
        ctiRequired,
        hacta,
        finalReportSubmissionDate,
        approvalExpiryDate,
    } = data;

    const getWorkFlow = () => {
        return reviewBoard ?? '-';
    };

    const getStatusDisplay = (statusId) => {
        if (statusId === APPROVED) {
            return 'Approved';
        } else if (statusId === DISAPPROVED) {
            return 'Disapproved';
        } else if (statusId === ACKNOWLEDGED) {
            return 'Acknowledged';
        } else {
            return '-';
        }
    };

    return (
        <SLayout>
            <SButtonLayout>
                <CustomButton
                    showMargin
                    onClick={() => {
                        dispatch(
                            setGlobal({
                                isDetailBack: true,
                            }),
                        );

                        history.push(getItem(KEY_PATHNAME) ?? `/applications/${application.folder || 'all'}`);
                    }}
                >
                    Back
                </CustomButton>
                {/* <CustomButton showMargin>Print</CustomButton> */}
            </SButtonLayout>
            <TextHeader style={{ marginTop: 20 }} underline>
                Application History
            </TextHeader>
            <TextSubHeader style={{ marginTop: 20 }}>General Information</TextSubHeader>
            <NumberListFormItem number={'1'} label={'Submission No.:'}>
                {subNo}
            </NumberListFormItem>
            <NumberListFormItem number={'2'} label={'Central IRB/CREC/IRB Reference No.:'}>
                {refNo ?? '-'}
            </NumberListFormItem>
            <NumberListFormItem number={'3'} label={'Application Submission Date:'}>
                {submissionDate ? getTimeWithTimeZone(submissionDate).format('YYYY-MM-DD HH:mm') : '-'}
            </NumberListFormItem>
            <NumberListFormItem number={'4'} label={'Application Confirmed Date:'}>
                {confirmDate ? getTimeWithTimeZone(confirmDate).format('YYYY-MM-DD HH:mm') : '-'}
            </NumberListFormItem>
            <NumberListFormItem number={'5'} label={'Type of sponsored study:'}>
                {checkNull(p4SponsorType)
                    ? 'No sponsor'
                    : p4SponsorType === true
                    ? 'Commercial'
                    : p4SponsorType === false
                    ? 'Non-commercial'
                    : 'Error'}
            </NumberListFormItem>
            <NumberListFormItem number={'6'} label={'Review Board:'}>
                {getWorkFlow() ?? '-'}
            </NumberListFormItem>
            <NumberListFormItem number={'7'} label={'Type of Review:'}>
                {checkNull(typeOfReview) ? '-' : typeOfReview}
            </NumberListFormItem>
            <NumberListFormItem number={'8'} label={'Review Decision for the study:'}>
                {reviewDecision !== null ? getStatusDisplay(reviewDecision) : '-'}
            </NumberListFormItem>

            <NumberListFormItem number={'9'} label={'Approval Expiry Date:'}>
                {approvalExpiryDate ? getTimeWithTimeZone(approvalExpiryDate).format('YYYY-MM-DD') : '-'}
            </NumberListFormItem>

            <NumberListFormItem number={'10'} label={'Decision Date (Study):'}>
                {decisionDate ? getTimeWithTimeZone(decisionDate).format('YYYY-MM-DD') : '-'}
            </NumberListFormItem>
            <NumberListFormItem number={'11'} label={'Is CTC required:'}>
                {ctcRequired === true ? 'Yes' : ctcRequired === false ? 'No' : '-'}
            </NumberListFormItem>
            <NumberListFormItem number={'12'} label={'Is CTI required:'}>
                {ctiRequired === true ? 'Yes' : ctiRequired === false ? 'No' : '-'}
            </NumberListFormItem>
            <NumberListFormItem number={'13'} label={'Is CTA required:'}>
                {ctaRequired === true
                    ? `Yes, ${hacta ? 'With HA' : 'With University'}`
                    : ctaRequired === false
                    ? 'No'
                    : '-'}
            </NumberListFormItem>
            <NumberListFormItem number={'14'} label={'Final Report Submission Date:'}>
                {finalReportSubmissionDate ? getTimeWithTimeZone(finalReportSubmissionDate).format('YYYY-MM-DD') : '-'}
            </NumberListFormItem>

            <TextSubHeader style={{ marginTop: 30 }}>CTC Expiry Date</TextSubHeader>
            <CustomTable style={{ marginTop: 15 }} rows={ctcRow} columns={ctcColumns} />
            <TextSubHeader style={{ marginTop: 30 }}>CTI Expiry Date</TextSubHeader>
            <CustomTable style={{ marginTop: 15 }} rows={ctiRow} columns={ctiColumns} />

            {(user.role === CCO || user.role === IRB || user.role === SECRETARY) && (
                <>
                    <TextSubHeader style={{ marginTop: 30 }}>CTA / CTA Amendment</TextSubHeader>
                    <CustomTable style={{ marginTop: 15 }} rows={ctaRows} columns={ctaColumns} />
                </>
            )}

            <TextSubHeader style={{ marginTop: 30 }}>Progress Report Submission</TextSubHeader>
            <CustomTable style={{ marginTop: 15 }} rows={progressRows} columns={progressColumns} />
            <TextSubHeader style={{ marginTop: 30 }}>Status History</TextSubHeader>
            <CustomTable test skipMaxHeight style={{ marginTop: 15 }} rows={statusRows} columns={statusColumns} />
            <TextSubHeader style={{ marginTop: 30 }}>Approval History</TextSubHeader>
            <CustomTable style={{ marginTop: 15 }} rows={approvalRows} columns={approvalColumns} />

            <TextSubHeader style={{ marginTop: 30 }}>Document Log</TextSubHeader>
            <CustomTable
                showAlternativeBackground
                skipMaxHeight
                style={{ marginTop: 15 }}
                rows={documentRows}
                columns={documentColumns}
            />
        </SLayout>
    );
};

export default ApplicationHistory;
